import { useState } from "react";
import { toast } from "sonner";
import { History } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { ImportDialog } from "@/components/app/ImportDialog";
import { useMe } from "@/components/app/MeContext";
import { useFetch } from "@/hooks/useFetch";
import { api, errMsg } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

// Admin-only, handover-period upload of historical LMs (headers only, approved, original LM numbers).
export function LegacyLmButton({ onDone }) {
  const { me } = useMe();
  const isAdmin = me.roles.includes("admin");
  const { data } = useFetch(isAdmin ? "/admin/legacy-lms" : null);
  const [open, setOpen] = useState(false);
  if (!isAdmin || !data?.enabled) return null;
  return (
    <>
      <Button variant="outline" onClick={() => setOpen(true)} data-testid="legacy-lm-upload-btn"><History className="h-4 w-4 mr-1" />Upload an existing LM</Button>
      <ImportDialog entity="legacy_lms" path="/admin/legacy-lms/import" title="Upload existing / historical LMs (admin, handover period)" open={open} onOpenChange={setOpen} onDone={onDone} />
    </>
  );
}

export function LegacyLmSwitch() {
  const { data, reload } = useFetch("/admin/legacy-lms");
  if (!data) return null;
  const set = async (v) => {
    if (!v && !window.confirm("Switch off the historical LM upload? Do this once the handover is complete.")) return;
    try { await api.put("/admin/legacy-lms", { enabled: v }); toast.success(v ? "Historical LM upload switched on" : "Historical LM upload switched off"); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="mt-8 rounded-md border border-slate-200 bg-white p-4 flex flex-wrap items-center gap-4" data-testid="legacy-lm-switch-card">
      <div className="flex-1 min-w-[240px]">
        <div className="text-sm font-semibold">Historical LM upload (handover period)</div>
        <div className="text-xs text-slate-500">Shows “Upload an existing LM” on the LM Register for admins. {data.uploaded} historical LM(s) uploaded so far.
          {data.changed_at && ` Last changed by ${data.changed_by} on ${fmtDateTime(data.changed_at)}.`}</div>
      </div>
      <span className="text-sm">{data.enabled ? "On" : "Off"}</span>
      <Switch checked={data.enabled} onCheckedChange={set} data-testid="legacy-lm-switch" />
    </div>
  );
}
